import NewInput from '../../NewInput';

const NumberInput = (props) => {
  const { takeDecimal = false } = props; // Deconstruct takeDecimal from props
  //const location = useLocation(); // Get the current route

  const onKeyDown = (event) => {
    const key = event.keyCode;

    // Block non-numeric characters
    if (
      key === 69 || // 'e'
      key === 107 || // '+'
      key === 109 || // '-'
      key === 187 || // '+/=' for some keyboards
      key === 189 || // '-' for some keyboards
      (key === 190 && !takeDecimal) || // Allow decimal points only if takeDecimal is true
      event.key === 'e' || // for 'e' letter check
      event.key === 'E'
    ) {
      event.preventDefault();
    }

    // Allow navigation keys
    if (
      key === 46 || // Delete
      key === 8 || // Backspace
      key === 37 || // Left arrow
      key === 39 || // Right arrow
      key === 9 || // Tab
      (key === 190 && !takeDecimal)
    ) {
      return; // Allow these actions
    }

    // Prevent inputting leading zero or space
    // if (event.target.value.trim() === '' && key === 48) {
    //   event.preventDefault();
    // }
  };

  const onPaste = (event) => {
    const pastedData = event.clipboardData.getData('Text');
    if (/[^0-9]/.test(pastedData) || pastedData.startsWith('0')) {
      event.preventDefault();
    }
  };

  return (
    <NewInput
      type='number'
      min='1'
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      {...props}
    />
  );
};

export default NumberInput;
